import * as _ from "lodash";

class ModuleTool {
  constructor(
    private context: __WebpackModuleApi.RequireContext,
    private basename: string,
    private path: string
  ) {}

  private _info?: {
    ext: string;
    filename: string;
    dirname: string;
  };

  get info() {
    if (!this._info) {
      const pointIndex = this.basename.lastIndexOf(".");
      this._info = {
        ext: this.basename.slice(pointIndex),
        filename: this.basename.slice(0, pointIndex),
        dirname: this.path.slice(0, this.basename.length),
      };
    }
    return this._info;
  }

  get module() {
    return this.context(this.path);
  }
}

export interface ModuleTree {
  files?: {
    [filename: string]: ModuleTool;
  };
  dirs?: {
    [dirname: string]: ModuleTree;
  };
}

export class RequireContextHelper {
  static toTree(context: __WebpackModuleApi.RequireContext) {
    const dir: ModuleTree = { files: {}, dirs: {} };
    context.keys().map((key) => {
      const path: string[] = [];
      key
        .split("/")
        .slice(1)
        .forEach((item, index, arr) => {
          if (index !== arr.length - 1) {
            path.push("dirs", item);
          } else {
            path.push("files", item);
            _.set(dir, path, new ModuleTool(context, item, key));
          }
        });
    });
    return dir;
  }
}
